import React, { useState } from 'react';
import { PaymentRequest } from './payment_request';
import { PaymentUI } from './razor_payment_request_UI';

import { getAdminBankDetails, getAdminBankQRCodeUrl } from '../../../controller/agent_data_controller';

export const DepositPaymentMain = () => {
    const [view, setView] = useState('landing'); // 'landing', 'manual', 'online'
    const [bankDetails, setBankDetails] = useState(null);
    const [loadingBankDetails, setLoadingBankDetails] = useState(true);

    React.useEffect(() => {
        const fetchBankDetails = async () => {
            const data = await getAdminBankDetails();
            setBankDetails(data);
            setLoadingBankDetails(false);
        };
        fetchBankDetails();
    }, []);

    const AdminDetails = () => (
        <div style={{ padding: '20px 42px' }}>
            <div style={{
                backgroundColor: 'white',
                padding: '30px',
                borderRadius: '12px',
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
                marginBottom: '30px',
                maxWidth: '600px'
            }}>
                <h3 style={{ fontSize: '18px', fontWeight: '600', marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '10px', color: '#333' }}>
                    Admin Payment Details
                </h3>

                {loadingBankDetails ? (
                    <p style={{ color: '#666' }}>Loading bank details...</p>
                ) : bankDetails ? (
                    <>
                        <div style={{ marginBottom: '20px' }}>
                            <p style={{ fontSize: '13px', color: '#888', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Bank Account Details</p>
                            <div style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '8px' }}>
                                <p style={{ margin: '6px 0', fontSize: '15px' }}><strong>Bank Name:</strong> {bankDetails.bankName}</p>
                                <p style={{ margin: '6px 0', fontSize: '15px' }}><strong>Account Name:</strong> {bankDetails.accountName}</p>
                                <p style={{ margin: '6px 0', fontSize: '15px' }}><strong>Account Number:</strong> {bankDetails.accountNumber}</p>
                                <p style={{ margin: '6px 0', fontSize: '15px' }}><strong>IFSC Code:</strong> {bankDetails.ifscCode}</p>
                            </div>
                        </div>

                        {bankDetails.upiId && (
                            <div style={{ marginBottom: '25px' }}>
                                <p style={{ fontSize: '13px', color: '#888', marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.5px' }}>UPI Details</p>
                                <div style={{ backgroundColor: '#f8f9fa', padding: '15px', borderRadius: '8px', display: 'flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap' }}>
                                    <div style={{ flex: 1, minWidth: '200px' }}>
                                        <p style={{ margin: '6px 0', fontSize: '15px' }}><strong>UPI ID:</strong> {bankDetails.upiId}</p>
                                    </div>
                                    {bankDetails.hasQRCode && (
                                        <div style={{ textAlign: 'center' }}>
                                            <p style={{ margin: '0 0 8px 0', fontSize: '12px', color: '#666' }}>Scan QR Code to Pay</p>
                                            <img 
                                                src={getAdminBankQRCodeUrl()} 
                                                alt="UPI QR Code" 
                                                style={{ maxWidth: '150px', borderRadius: '8px', border: '1px solid #ddd', backgroundColor: 'white', padding: '5px' }} 
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                    </>
                ) : (
                    <p style={{ color: '#d9534f', padding: '15px', backgroundColor: '#fdf3f2', borderRadius: '8px' }}>
                        Bank details not available. Please contact the administrator.
                    </p>
                )}

                <div style={{ display: 'flex', gap: '15px', marginTop: '25px' }}>
                    <button
                        onClick={() => setView('manual')}
                        style={{
                            flex: 1,
                            padding: '12px',
                            borderRadius: '8px',
                            border: 'none',
                            backgroundColor: 'rgba(55, 101, 165, 1)',
                            color: 'white',
                            cursor: 'pointer',
                            fontSize: '15px',
                            fontWeight: '500',
                        }}
                    >
                        Submit Payment Receipt
                    </button>
                    <button
                        onClick={() => setView('online')}
                        style={{
                            flex: 1,
                            padding: '12px',
                            borderRadius: '8px',
                            border: 'none',
                            backgroundColor: '#3399cc',
                            color: 'white',
                            cursor: 'pointer',
                            fontSize: '15px',
                            fontWeight: '500',
                        }}
                    >
                        Pay with Razorpay
                    </button>
                </div>
            </div>
        </div>
    );

    return (
        <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
            <div style={{ display: 'flex', alignItems: 'center', margin: '30px 50px 0 42px' }}>
                {view !== 'landing' && (
                    <div onClick={() => setView('landing')} className='submit-button-variable' style={{ marginRight: '20px', cursor: 'pointer' }}>
                        <span>🡐 Back</span>
                    </div>
                )}
                <p className='title-demo' style={{ margin: '0' }}>Deposit Payment</p>
            </div>

            <div style={{ flex: 1, overflowY: 'auto' }}>
                {view === 'landing' && <AdminDetails />}
                {view === 'manual' && <PaymentRequest />}
                {view === 'online' && <PaymentUI />}
            </div>
        </div>
    );
};
